import React, { Component } from "react";
import { Text, View, TouchableOpacity, Platform } from "react-native";
import {
  postSingle,
  Flex,
  Padding,
  Margin,
  Helpers,
  featuredArticle,
  homeCover,
  FontFamily,
  articleLists,
  articleItem,
} from "../../styles/appStyles";
import CustomImage from "../custom-image";
import { helpers } from "../../utils/helpers";
import TouchableOpacityLink from "../touchable-opacity-link";
import moment from "moment";
import getImagePath from "../../utils/image-helper";
import { Mixpanel } from "../../utils/mixpanel";

const textIcon = getImagePath("img/of-the-day-blue.png");
const textIconDark = getImagePath("img/of-the-day-dark.png");

export class HomeCover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAllAuthors: false,
    };
  }

  componentDidMount = () => {};

  trackStoryClick = (data) => {
    // try {
    //     Mixpanel.track('click_story_of_the_day', { title: data.title, author: data.author[0].name, date: data.published_date, category: data.category.slug });
    // }
    // catch (error) {
    //     console.log("mix panel error =>", error);
    // }
  };

  trackCateoryClick = (item) => {
    // try {
    //     Mixpanel.track('category', { category_slug: item.category.slug, source_section_type: 'home-banner', section_value: { title: item.name, slug: item.slug } });
    // }
    // catch (error) {
    //     console.log("mix panel error =>", error);
    // }
  };

  render() {
    const {
      data,
      require,
      viewArticle,
      viewCategory,
      viewAuthor,
      lazyLoad,
      darkMode,
    } = this.props;
    const { showAllAuthors } = this.state;
    let categoryClick, btnClick, authorBtnClick;
    if (helpers.isWeb()) {
      categoryClick = {
        to: "/category/" + data.category.slug,
      };
      btnClick = {
        to: {
          pathname: "/" + data.category.slug + "/" + data.slug,
          postData: data,
        },
      };
      authorBtnClick = {
        to: "/writers/" + data.author[0].slug,
      };
    } else {
      categoryClick = {
        onPress: () => viewCategory(data.category.slug),
      };
      btnClick = {
        onPress: () => viewArticle(data.category.slug, data.slug, data),
      };
      authorBtnClick = {
        onPress: (event) => {
          event.stopPropagation();
          viewAuthor(data.author[0].slug);
        },
      };
    }

    return (
      <View
        style={[
          {
            paddingTop: 30,
            paddingBottom: helpers.isDesktop() ? 30 : 36,
            backgroundColor: "#f8f8f8",
          },
          darkMode && { backgroundColor: "#1E1E1E" },
        ]}
      >
        <View
          style={[
            Helpers.conatinerWeb,
            helpers.isDesktop() && Helpers.conatinerWebFull,
          ]}
        >
          <View
            style={[Padding.ph_2, !helpers.isDesktop() && Flex.alignCenter]}
          >
            <View style={[Flex.fill]}>
              {helpers.isWeb() ? (
                <Text
                  style={[
                    Margin.mt_0,
                    Margin.mb_0,
                    homeCover.title,
                    homeCover.firstText,
                    homeCover.title,
                    helpers.isDesktop() && homeCover.titleDesktop,
                    Helpers.textUppercase,
                  ]}
                >
                  <Text
                    style={[
                      homeCover.secondText,
                      {
                        width: helpers.isDesktop() ? 375 : 200,
                        marginBottom: -3,
                        marginRight: 6,
                      },
                    ]}
                  >
                    Story
                  </Text>
                  <CustomImage
                    source={darkMode ? textIconDark : textIcon}
                    require={true}
                    webStyle={{
                      width: helpers.isDesktop() ? 370 : 170,
                      height: "auto",
                      objectFit: "contain",
                      paddingLeft: helpers.isDesktop() ? 8 : 5,
                      marginBottom: darkMode
                        ? 0
                        : helpers.isDesktop()
                        ? -2
                        : -1,
                    }}
                  />
                </Text>
              ) : (
                <View
                  style={[
                    Margin.mt_0,
                    Margin.mb_0,
                    Flex.row,
                    Flex.alignCenter,
                    Flex.justfiyCenter,
                  ]}
                >
                  <Text
                    style={[
                      homeCover.title,
                      homeCover.firstText,
                      homeCover.title,
                      helpers.isDesktop() && homeCover.titleDesktop,
                      Helpers.textUppercase,
                      homeCover.secondText,
                      { width: "auto" },
                      !helpers.isWeb() && { fontFamily: FontFamily.semiBold },
                    ]}
                  >
                    Story
                  </Text>
                  <CustomImage
                    source={darkMode ? textIconDark : textIcon}
                    require={true}
                    style={{
                      width: 175,
                      height: 21,
                      resizeMode: "contain",
                      marginLeft: 2,
                      marginTop: 1,
                    }}
                    webStyle={{
                      width: helpers.isDesktop() ? 370 : 170,
                      height: "auto",
                      objectFit: "contain",
                      paddingLeft: helpers.isDesktop() ? 8 : 5,
                      marginBottom: helpers.isDesktop() ? -2 : -1,
                    }}
                  />
                </View>
              )}
            </View>
          </View>
          <TouchableOpacityLink
            {...btnClick}
            handleClick={() => {
              this.trackStoryClick(data);
            }}
          >
            <View style={[helpers.isDesktop() && Flex.row]}>
              <View
                style={[
                  Margin.mt_1,
                  Margin.mb_2,
                  helpers.isDesktop() && Padding.ph_2,
                  {
                    position: "relative",
                    width: helpers.isDesktop() ? "56%" : "100%",
                  },
                ]}
              >
                <CustomImage
                  source={data.featured_image.url}
                  require={require}
                  style={{
                    width: "100%",
                    height: 295,
                  }}
                  webStyle={{
                    width: "auto",
                    height: helpers.isDesktop() ? 410 : 295,
                    objectFit: "cover",
                  }}
                  resizeMode={"cover"}
                  altText={
                    data.featured_image.alt && data.featured_image.alt != ""
                      ? data.featured_image.alt
                      : data.title
                      ? data.title
                      : data.story?.title
                      ? data.story.title
                      : data.featured_image.title
                  }
                  lazyLoad={lazyLoad ? true : false}
                />
              </View>
              <View
                style={{ width: helpers.isDesktop() ? "44%" : "100%", flex: 1 }}
              >
                <View
                  style={[
                    Margin.mb_2,
                    !helpers.isDesktop() && Margin.mb_1,
                    { marginTop: helpers.isDesktop() ? 8 : 0 },
                  ]}
                >
                  <View
                    style={[Flex.fill, !helpers.isDesktop() && Padding.ph_2]}
                  >
                    <TouchableOpacityLink
                      {...categoryClick}
                      handleClick={() => this.trackCateoryClick(data)}
                    >
                      <Text
                        style={[
                          Margin.mb_0,
                          Helpers.textUppercase,
                          articleLists.badge,
                          helpers.isDesktop() && Padding.ph_2,
                          {
                            fontSize: helpers.isDesktop() ? 22 : 15,
                            textAlign: "left",
                            fontFamily: FontFamily.regular,
                            letterSpacing: helpers.isDesktop() ? 1 : 0.5,
                            color: "rgb(144, 124, 255)",
                          },
                          !helpers.isWeb() && {
                            fontFamily: FontFamily.semiBold,
                          },
                          darkMode && { color: "#5263F4" },
                        ]}
                      >
                        {data.category.name}
                      </Text>
                    </TouchableOpacityLink>
                  </View>
                </View>
                <View
                  style={[
                    helpers.isDesktop() && Flex.column,
                    helpers.isDesktop() && Flex.justifyBetween,
                    !helpers.isDesktop() && Padding.ph_2,
                  ]}
                >
                  <View style={[Flex.fill]}>
                    <Text
                      style={[
                        Margin.mt_0,
                        Margin.mb_0,
                        homeCover.heading,
                        helpers.isDesktop() && homeCover.headingDesktop,
                        helpers.isDesktop() && Padding.ph_2,
                        ,
                        { maxWidth: "100%", paddingTop: 0, color: "#000" },
                        darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                      ]}
                    >
                      {data.title}
                    </Text>
                    <Text
                      style={[
                        homeCover.content,
                        helpers.isDesktop() && homeCover.contentDesktop,
                        helpers.isDesktop() && Padding.ph_2,
                        helpers.isDesktop() && Margin.mt_3,
                        !helpers.isDesktop() && Margin.mt_1,
                        helpers.isDesktop() && Margin.mb_2,
                        ,
                        { maxWidth: "100%", color: "#292929" },
                        darkMode && { color: "rgba(255, 255, 255, 0.6)" },
                      ]}
                      numberOfLines={3}
                    >
                      {data.strapline ? data.strapline : data.excerpt}
                    </Text>
                    {!helpers.isDesktop() && (
                      <View
                        style={[
                          featuredArticle.lineBreak,
                          Margin.mt_2,
                          Margin.mb_2,
                        ]}
                      ></View>
                    )}
                  </View>
                  <View
                    style={[
                      postSingle.authorDetailsWrap,
                      helpers.isDesktop() && Flex.row,
                      helpers.isDesktop() && Flex.justfiyCenter,
                      helpers.isDesktop() && Flex.justifyStart,
                      helpers.isDesktop() && Padding.ph_2,
                      Flex.FlexWrap,
                      helpers.isDesktop() && {
                        alignItems: "center",
                        paddingTop: helpers.isDesktop() ? 10 : 0,
                      },
                    ]}
                  >
                    <TouchableOpacityLink {...authorBtnClick}>
                      <View
                        style={[
                          postSingle.authorDetailsWrap,
                          Flex.alignCenter,
                          Flex.justfiyCenter,
                          helpers.isDesktop() && Flex.justifyStart,
                          { marginRight: 15, marginBottom: 15 },
                        ]}
                      >
                        <View
                          style={[
                            postSingle.authorPicWrap,
                            {
                              width: helpers.isDesktop() ? 65 : 42,
                              height: helpers.isDesktop() ? 65 : 42,
                            },
                          ]}
                        >
                          <CustomImage
                            source={data.author[0].profile_image}
                            require={false}
                            webStyle={{
                              width: helpers.isDesktop() ? 59 : 38,
                              height: helpers.isDesktop() ? 59 : 38,
                              borderRadius: 100,
                            }}
                            resizeMode={"contain"}
                            style={postSingle.authorThumbPic}
                            altText={data.author[0].name}
                          />
                        </View>
                        <View style={[Padding.pl_1]}>
                          <Text
                            style={[
                              postSingle.authorName,
                              helpers.isDesktop() &&
                                postSingle.authorNameDesktop,
                              { paddingBottom: helpers.isDesktop() ? 0 : 2 },
                              { fontSize: helpers.isDesktop() ? 18 : 15 },
                              darkMode && {
                                color: "rgba(255, 255, 255, 0.89)",
                              },
                            ]}
                          >
                            {data.author[0].name}
                          </Text>
                        </View>
                      </View>
                    </TouchableOpacityLink>
                    {data.author.length > 1 && (
                      <>
                        {showAllAuthors ? (
                          <>
                            {data.author.map((author, aindex) => {
                              if (aindex == 0) {
                                return false;
                              }
                              let authorBtnClickOthers;
                              if (helpers.isWeb()) {
                                authorBtnClickOthers = {
                                  to: "/writers/" + author.slug,
                                };
                              } else {
                                authorBtnClickOthers = {
                                  onPress: (event) => {
                                    event.stopPropagation();
                                    viewAuthor(author.slug);
                                  },
                                };
                              }
                              return (
                                <TouchableOpacityLink {...authorBtnClickOthers}>
                                  <View
                                    style={[
                                      postSingle.authorDetailsWrap,
                                      Flex.alignCenter,
                                      Flex.justfiyCenter,
                                      helpers.isDesktop() && Flex.justifyStart,
                                      { marginRight: 15, marginBottom: 15 },
                                    ]}
                                  >
                                    <View
                                      style={[
                                        postSingle.authorPicWrap,
                                        {
                                          width: helpers.isDesktop() ? 65 : 42,
                                          height: helpers.isDesktop() ? 65 : 42,
                                        },
                                      ]}
                                    >
                                      <CustomImage
                                        source={author.profile_image}
                                        require={false}
                                        webStyle={{
                                          width: helpers.isDesktop() ? 59 : 38,
                                          height: helpers.isDesktop() ? 59 : 38,
                                          borderRadius: 100,
                                        }}
                                        resizeMode={"contain"}
                                        style={postSingle.authorThumbPic}
                                        altText={author.name}
                                      />
                                    </View>
                                    <View style={[Padding.pl_1]}>
                                      <Text
                                        style={[
                                          postSingle.authorName,
                                          helpers.isDesktop() &&
                                            postSingle.authorNameDesktop,
                                          {
                                            paddingBottom: helpers.isDesktop()
                                              ? 0
                                              : 2,
                                          },
                                          {
                                            fontSize: helpers.isDesktop()
                                              ? 18
                                              : 15,
                                          },
                                          darkMode && {
                                            color: "rgba(255, 255, 255, 0.89)",
                                          },
                                        ]}
                                      >
                                        {author.name}
                                      </Text>
                                    </View>
                                  </View>
                                </TouchableOpacityLink>
                              );
                            })}
                          </>
                        ) : (
                          <TouchableOpacity
                            onPress={() =>
                              this.setState({ showAllAuthors: true })
                            }
                          >
                            <View
                              style={{
                                backgroundColor: "rgba(169, 125, 241, 0.05)",
                                width: 28,
                                height: 28,
                                borderRadius: 50,
                                borderWidth: 1,
                                borderColor: "#A97DF1",
                                padding: 2.4,
                                marginBottom: 15,
                              }}
                            >
                              <Text
                                style={{
                                  color: "#A97DF1",
                                  fontFamily: FontFamily.regular,
                                  fontWeight: "500",
                                  fontSize: 18,
                                  textAlign: "center",
                                }}
                              >
                                +{data.author.length - 1}
                              </Text>
                            </View>
                          </TouchableOpacity>
                        )}
                      </>
                    )}
                    {/* {helpers.isDesktop() && <Text style={[featuredArticle.postDate, helpers.isDesktop() &&  featuredArticle.postDateDesktop, {fontSize: helpers.isDesktop() ? 18 : 13}, {marginBottom: helpers.isDesktop() ? 30 : 16, paddingBottom: 2, textAlign: 'left'}]}>{moment(data.published_date).format("DD MMMM, YYYY")}</Text>} */}
                  </View>
                  {/*{!helpers.isDesktop() && <Text style={[featuredArticle.postDate, helpers.isDesktop() &&  featuredArticle.postDateDesktop, {fontSize: helpers.isDesktop() ? 18 : 13}, {textAlign: 'left'}]}>{moment(data.published_date).format("DD MMMM, YYYY")}</Text>}*/}
                </View>
              </View>
            </View>
          </TouchableOpacityLink>
        </View>
      </View>
    );
  }
}
export default HomeCover;
